import Members from "./components/members"
import MemberForm from "./components/memberForm"
import MembersList from "./components/membersList"
const MemerberListing = () => {
	return <div >
		<Members />
		<MembersList/>
		<MemberForm />
	</div>
}
export default MemerberListing